<template>
  <div @contextmenu="selectComponentDEV($event, schema.model)" :class="[getSelectedDEV && 'dev-selected-component']">
    <v-simple-table v-bind="schema.attributes">
      <template v-slot:default>
        <thead v-if="schema.attributes.showHeader">
          <tr>
            <th width="95%" class="text-left">Nome do Documento</th>
            <th width="5%"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in schema.itemsTable" :key="item.name">
            <td width="95%">{{ item.name }}</td>
            <td width="5%">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn text icon color="primary" v-on="on" @click="downloadDocument(item)">
                    <v-icon>get_app</v-icon>
                  </v-btn>
                </template>
                <span>Baixar Arquivo</span>
              </v-tooltip>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';
import ECM from '@/services/ecm';
import { downloadFile } from '@/helpers/utils';

export default {
  mixins: [abstractField, devComponentMixin],

  methods: {
    getHash(item) {
      let hash = item.id_document.toString().padStart(9, '0');

      return `${hash}${item.nm_key}`;
    },

    async downloadDocument(item) {
      let hash = this.getHash(item);
      const { data } = await ECM.DownloadDocument(hash);

      downloadFile(data.content, data.contentType, data.fileName.split('.').pop(), data.fileName.split('.').shift());
    }
  }
};
</script>
